module.exports = __webpack_public_path__ + "img/cross.7bb6a154.svg";